<template>
  <div class="main_container main_container_fixed">
    <div class="sub_container w-row">
      <div class="column-10 w-col w-col-3"></div>
      <div class="column-2 w-col w-col-6">
        <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
         <h1 v-if="isSendEmail" class="heading-3">{{$t('SEND_OFFER')}}</h1>
        <p class="body_small" v-html="$t(helpTexts)"></p>
      </div>
       <div class="column-16 w-col w-col-3"></div>
    </div>
      <div class="sub_container w-form">
        <email-confirmation v-if="step === 1" :data="data"   @email-confirmation="emailConfirmation" />
        <otp-confirmation v-if="step === 2" :data="data" @otp-confirmation="otpConfirmation" :otp-confirmation="OTP_CONFIRMATION" />
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EmailConfirmation from './ComponentsEmailValidation/EmailConfirmation.vue';

export default {
  data() {
    return {
      step: 1,
      I_EMAIL_ADDRESS: '',
      I_TOKEN: '',
      OTP_CONFIRMATION: true
      /*  helpTexts: {
         1: 'EMAIL_CONFIRMATION_BEFORE_SEND_EMAIL',
         2: 'OTP_VALIDATION'
       } */
    };
  },
  components: {
    EmailConfirmation,
    OtpConfirmation: () => import('./ComponentsEmailValidation/OtpConfirmation.vue')
  },
  created() {
    if (!(Object.prototype.hasOwnProperty.call(this.$store.state[this.$route.params.product][this.$route.params.product], 'CS_CONFIRMATION'))) {
      this.$router.push({ path: `/${this.$route.params.product}` });
    }
  },
  computed: {
    data() {
      const CS_CONFIRMATION = this.$store.state[this.$route.params.product][this.$route.params.product] && this.$store.state[this.$route.params.product][this.$route.params.product].CS_CONFIRMATION
        ? this.$store.state[this.$route.params.product][this.$route.params.product].CS_CONFIRMATION
        : {
          EMAIL: '',
          OTP_CODE: ''
        };
      return CS_CONFIRMATION;
    },
    isSendEmail() {
      return this.$store.getters[`${this.$route.params.product}/getSendEmail`];
    },
    helpTexts() {
      if (this.step === 1) {
        return this.isSendEmail ? 'EMAIL_CONFIRMATION_BEFORE_SEND_EMAIL' : 'EMAIL_CONFIRMATION_BEFORE_CONTRACT';
      }
      if (this.step === 2) {
        return this.isSendEmail ? 'OTP_VALIDATION_SEND_OFFER' : 'OTP_VALIDATION_PAYMENT';
      }
      return '';
    }
  },
  methods: {
    ...mapActions('emailConfirmation', ['emailValidationAction', 'otpValidationAction']),
    async emailConfirmation() {
      const response = await this.emailValidationAction({ I_EMAIL_ADDRESS: this.data.EMAIL });
      if (response) {
        this.step++;
      }
    },
    async otpConfirmation() {
      this.OTP_CONFIRMATION = await this.otpValidationAction({ I_EMAIL_ADDRESS: this.data.EMAIL, I_TOKEN: this.data.OTP_CODE });
      if (this.OTP_CONFIRMATION) {
        if (this.isSendEmail) {
          this.$router.push({ path: `/${this.$route.params.product}/send-offer` });
        } else {
          this.$router.push({ path: `/${this.$route.params.product}/payment` });
        }
      }
    },
  },
};
</script>
